export default {
  getExplanation: (state) => state.explanation,
};
